import UsersApi from '@/frontend/api/user';
import { ElMessage, ElLoading } from 'element-plus';
import { mapGetters } from 'vuex';
export default {
  name: "ProfilePage",

  data() {
    return {
      Compilations: [],
      formCompilation: {}
    };
  },

  computed: mapGetters(['user']),
  methods: {
    switchTab(name) {
      let loader = ElLoading.service({
        lock: false,
        text: 'Загрузка'
      });

      if (name === 'profile') {
        this.activeTab = name;
      }

      if (name === 'compilations') {
        this.activeTab = name;
      }

      loader.close();
    },

    logout() {
      UsersApi.logout().then(() => window.location.href = '').catch(error => {
        console.error(error);
        ElMessage.error('Неизвестная ошибка');
      });
    }

  }
};